import axios, { AxiosInstance, Method, AxiosRequestConfig } from 'axios';
import { getAuthData, setAuthData, clearAuthData } from './authData';
import { getEnvironmentConfig } from './environment';

const { apiUrl } = getEnvironmentConfig();
export const API_URL = apiUrl;

export interface AxiosResponseData {
  [key: string]: any;
}

export const instance: AxiosInstance = axios.create({
  baseURL: API_URL,
  responseType: 'json',
});

/* request interceptor */
instance.interceptors.request.use((request) => {
  if (!request.url?.includes('https://')) {
    Object.assign(request.headers, getAuthData());
  }

  return request;
});

/* response interceptor */
instance.interceptors.response.use(
  (config) => {
    if (config.data?.accessToken) {
      if (config.config.url === '/auth/one-time-entry') {
        const mainToken = localStorage.getItem('Authorization');
        const mainCompanyId = localStorage.getItem('company-id');
        if (mainToken) {
          localStorage.setItem('mainToken', mainToken);
          if (mainCompanyId) {
            localStorage.setItem('mainCompanyId', mainCompanyId);
            localStorage.removeItem('company-id');
          }
        }
        localStorage.setItem('isSuperAdminLogged', 'true');
      }
      setAuthData({ Authorization: `Bearer ${config.data.accessToken}` });
    }

    return config.data;
  },
  (responseData = {}) => {
    const { response, message } = responseData;
    const data = response?.data;
    const status = response?.status;

    if (
      status === 401 &&
      data.message === 'Unauthorized' &&
      response?.request.responseURL !== 'https://api.dev.builderpad.com/company'
    ) {
      clearAuthData();
    }

    return Promise.reject({ data, message, status });
  }
);

type URL = string | ((id?: number | string) => string);

interface IArg extends AxiosRequestConfig {
  id?: number | string;
}

export type GetAxiosResponse = <T = AxiosResponseData>(args?: IArg) => Promise<T>;

export type TMakeAxiosRequest = (url: URL, method: Method) => GetAxiosResponse;

const makeAxiosRequest: TMakeAxiosRequest =
  (url, method) =>
    (args = {}) => {
      const { id } = args;
      return instance({
        url: typeof url === 'function' ? url(id) : url,
        method,
        ...args,
      }) as Promise<any>;
    };

export default makeAxiosRequest;
